import {DossierT10, DossierT2000} from "./base.model";

export class DictListType {
  code?: DossierT10 = '';
  name?: DossierT2000 = '';
  row?: number;
}
